import React, { PureComponent, cloneElement } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { contentManagementAction } from '../../../reducers/contentMangementData';
import { AddContent } from '../../MyLibrary';
import { handleContentSelect, handleAddContent, handleDeleteContent, handleDeleteContentFromChapter } from './helpers/myLibraryFunctions';
import { preSelectedFilter, setGoalsDriller, getContentDataIds } from './helpers/preSelectedFilters';
import { showMsg } from '../../../../course/actions/loaderAlert';
import courseService from '../../../../mylibrary/services/courseService';
import contentManagementService from '../../../service/courseManagementServices';
import { AddBonusDialog } from '../../PopUp';
import { ExpansionalPanel } from '../../ExpansionPanel';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';
import { createStyles, WithStyles } from '@material-ui/core';
import getChapterNumber from '../helper/getChapterNumber';
import { isLastInstanceOfChapter } from './helpers/isLastInstanceOfChapter';

const styles = (theme: Theme) =>
  createStyles({
    handleDragIcon: {
      position: 'absolute',
      left: 0,
      top: 29,
      zIndex: 9,
    },
    manageDragable: {
      position: 'relative',
      paddingLeft: 15,
      '&>:first-child': {
        '&>:first-child': {
          padding: '0!important',
          marginBottom: '0!important',
        },
      },
    },
  });
interface ConceptPhaseProps extends WithStyles<typeof styles> {
  classes: any;
}
interface ConceptPhaseProps {
  conceptPhaseData: any;
  bulkDrag: any;
  treeData: any;
  preFilters: any;
  getPackageByIdData: any;
  filterSelectedQuestion: any;
  showMessage: any;
  setBulkDrag: Function;
  setTreeData: Function;
  setPreFilters: Function;
  setFilterSelectedQuestion: Function;
  subjectTab: any;
  childIndex:number;
}

interface ConceptPhaseState {
  hasContent: boolean;
  isOpened: boolean;
  openBonusContent: boolean;
  bonusContent: boolean;
  openMyLibray: boolean;
  selectedQuestion: any;
  selectedQuestionCount: number;
  preSelectedFilter: any;
  bonusCriteria: any[];
  isDragEnabled: boolean;
  isExpansionPanelOpen: boolean;
  tempQuestions: any;
  isChapterLevel:boolean;
}

const grid = 5;
class ConceptPhase extends PureComponent<ConceptPhaseProps, ConceptPhaseState> {
  constructor(props: ConceptPhaseProps) {
    super(props);
    this.state = {
      hasContent: this.props.conceptPhaseData.content.length ? true : false,
      isOpened: true,
      openMyLibray: false,
      bonusContent: false,
      selectedQuestion: [],
      selectedQuestionCount: 0,
      preSelectedFilter,
      openBonusContent: false,
      bonusCriteria: [],
      isDragEnabled: false,
      isExpansionPanelOpen: false,
      tempQuestions: [],
      isChapterLevel:false
    };
  }

  toggleAddBonusContent = (isChapterLevel?:boolean) => {
    this.setState((prevState) => ({
      openBonusContent: !prevState.openBonusContent,
      isChapterLevel
    }));
  };

  handleClick = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  // getConceptId = () => {
  //   const { conceptPhaseData, treeData } = this.props;
  //   const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
  //   const { phases = [] } = treeData;
  //   const conceptId = phases[phaseIndex]
  //   ['weeks']
  //   [weekIndex]['subjects']
  //   [subjectIndex]['chapters']
  //   [chapterIndex]['concepts'][conceptIndex].content.map((ele: any) => ele && ele.id);
  //   return conceptId;
  // }

  getContentType = (type: string) => {
    switch (type) {
      case 'studyNotes':
        return 'note';
      case 'video':
        return 'videos';
      case 'formula':
        return 'formulas';
      case 'test':
        return 'testpapers';
    }
  }

  handleContentSelectFromLibrary = (content: any, totalCount?: number) => {
    const mainTestTypes = ['full', 'part', 'combined']
    const indexToCheck = content.length - 1;
    if(content[indexToCheck] && mainTestTypes.includes(content[indexToCheck].contentSubTypeCode)){
      this.props.showMessage('Main test cannot be added in concept phase', 'error');
      return;
    }
    const contentLength = totalCount || content.length;
    handleContentSelect(content, contentLength, this.handleSetState)
  };
  handleAddContentFromLibrary = (bonusContent?: boolean, bonusCriteria?: any) => {
    const { treeData, setTreeData, conceptPhaseData, showMessage } = this.props;
    const { tempQuestions: contents = {},isChapterLevel} = this.state;
    const isPanelOpen = handleAddContent(
      { contents, treeData, setTreeData, conceptPhaseData, bonusContent, bonusCriteria,isChapterLevel},
      this.handleSelectedFilterQuestion,
      showMessage
    );
    this.setState({
      isExpansionPanelOpen: isPanelOpen,
    });
  };

  getItemStyle = (isDragging: any, draggableStyle: any) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? 'lightgrey' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  enableDrag = () => {
    this.setState({ isDragEnabled: true });
  };
  disableDrag = () => {
    this.setState({ isDragEnabled: false });
  };
  handleOnChangeCheckBox = (event: any, key: string) => {
    event.stopPropagation();
    const { bulkDrag, setBulkDrag,treeData,conceptPhaseData } = this.props;
    let cloneBulkDrag = JSON.parse(JSON.stringify(bulkDrag));
    const {
      name = '',
      subjectIndex,
      chapterIndex,
      phaseIndex,
      weekIndex,
      subjectName
    } = conceptPhaseData;
   if(!event.target.checked){
    const newKey = `chapter-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}`;
      delete cloneBulkDrag[newKey];
   } 
    cloneBulkDrag = {
      ...cloneBulkDrag,
      [key]: event.target.checked,
    };
    setBulkDrag({
      bulkDrag: { ...cloneBulkDrag },
    });
  };
  handleSetState = (updatedStateValues: any) => {
    this.setState((prevState) => ({
      ...prevState,
      ...updatedStateValues,
    }));
  };
  handlePreFiltersData = (key: any, data: any) => {
    const { preFilters, setPreFilters } = this.props;
    setPreFilters({
      preFilters: {
        ...JSON.parse(JSON.stringify(preFilters)),
        [key]: JSON.parse(JSON.stringify(data)),
      },
    });
  };
  handlePreFilterDataWithBulk = (bulkData: any) => {
    const { preFilters, setPreFilters } = this.props;
    setPreFilters({
      preFilters: {
        ...JSON.parse(JSON.stringify(preFilters)),
        ...JSON.parse(JSON.stringify(bulkData))
      },
    });
  }
  handleSelectedFilterQuestion = (content: any) => {
    const { filterSelectedQuestion, setFilterSelectedQuestion, conceptPhaseData } = this.props;
    const {isChapterLevel}=this.state;
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData
    const phaseKey = `${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${isChapterLevel?conceptIndex+1:conceptIndex}`;
    let contentData = [...content];
    if (content && content.length) {
      let newFilteredContent = [...filterSelectedQuestion, ...contentData];
      setFilterSelectedQuestion({
        filterSelectedQuestion: [...JSON.parse(JSON.stringify(newFilteredContent))],
      });
      const excludedIds = contentData.map((ele: any) => ele.content_Id || ele.id);
      let clonePreFilters = this.props.preFilters[phaseKey];
      clonePreFilters = { ...clonePreFilters, excludedIds: [...clonePreFilters.excludedIds, ...excludedIds] };
      this.handlePreFiltersData(phaseKey, clonePreFilters);
    }
  };
  handleRemoveFilterQuestion = (content: any) => {
    const { filterSelectedQuestion, setFilterSelectedQuestion, preFilters, conceptPhaseData } = this.props;
    let newFilteredQuestion = filterSelectedQuestion.filter((element: any) => (element.id && element.id !== content.id || element.content_Id && element.content_Id !== content.id));
    setFilterSelectedQuestion({
      filterSelectedQuestion: [...JSON.parse(JSON.stringify(newFilteredQuestion))],
    });
  };
  toggleOpenMyLibrary = async (bonusContent?: boolean,isChapterLevel:boolean=false) => {
    const {conceptPhaseData,preFilters,setPreFilters,treeData,getPackageByIdData}=this.props;
    const{weekIndex,subjectIndex,chapterIndex,conceptIndex,phaseIndex}=conceptPhaseData;
    await this.callGoalsDrillersApi();
    if(isChapterLevel){
        if(Boolean(Object.keys(preFilters).length)){
         if(!preFilters.hasOwnProperty(`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex+1}`)){
          let chapterObj=JSON.parse(JSON.stringify(preFilters[`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]));
          chapterObj.goalsDriller.level='chapter';
           let lvl1=chapterObj.contentFilterData.find((data:any)=>{
            return data.filterValue==='contentType';
             });
           if(lvl1){
              lvl1.filters.forEach((d1:any)=>{
                if(d1.filterValue==='testpapers'){
                  d1.filters.push({
                   "filterValue": "chap",
                   "isSelected": true,
                   "disabled": false,
                   "filters": []
                  });
                }});
           }
           const newPrefilters={...preFilters};
           const key=`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex+1}`;
           this.props.setPreFilters({
            preFilters: {
              ...JSON.parse(JSON.stringify(preFilters)),
              [key]:chapterObj,
            },
          }) 
         }
       } 
     }
    if (!bonusContent) {
      this.setState((prevState) => ({
        openMyLibray: !prevState.openMyLibray,
        bonusContent: false,
        isChapterLevel
      }));
    } else {
      this.setState((prevState) => ({
        openMyLibray: !prevState.openMyLibray,
        bonusContent,
        isChapterLevel
      }));
    }
  };
  handleBonusContent = (percentageValue: string) => {
    this.toggleAddBonusContent();
    let bonusCriteria: any = [];
    const {isChapterLevel}=this.state;
    bonusCriteria.push({
      name: 'proficiency',
      value: percentageValue,
    });
    this.setState(
      {
        bonusCriteria,
      },
      () => this.toggleOpenMyLibrary(true,isChapterLevel)
    );
    // this.handleAddContentFromLibrary(true, bonusCriteria);
  };
  handleContentSelectAll = (selectedQuestion: any, totalCount?:number) => {
    this.handleContentSelectFromLibrary(selectedQuestion, totalCount)
  };
  handleDeleteContent = (contentItem: any) => {
    const { treeData, setTreeData, conceptPhaseData, preFilters } = this.props;
    handleDeleteContent({ treeData, setTreeData, contentItem, conceptPhaseData, preFilters }, this.handlePreFilterDataWithBulk);
    this.handleRemoveFilterQuestion(contentItem);
  };
  handleDeleteContentFromChapter = (contentItem: any) => {
    const { treeData, setTreeData, conceptPhaseData } = this.props;
    handleDeleteContentFromChapter({ treeData, setTreeData, contentItem, conceptPhaseData });
    this.handleRemoveFilterQuestion(contentItem);
  };
  handleTestVisibilityToggle = (contentItem: any, isHidden: any, isConceptLevelContent: boolean) => {
    const { treeData, setTreeData, conceptPhaseData } = this.props;
    const { phases = [] } = treeData;
    let cloneTree = JSON.parse(JSON.stringify(treeData));
    let clonePhases = JSON.parse(JSON.stringify(phases));
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
    const content = !isConceptLevelContent ? 
    clonePhases[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'][chapterIndex]['content']
    : clonePhases[phaseIndex]['weeks'][weekIndex]['subjects'][subjectIndex]['chapters'][chapterIndex]['concepts'][conceptIndex]['content'];
    for(let i=0;i<content.length;i++){
        const id = _.get(content,`${i}.testDetails.testId`,'');
        if (id === contentItem['testDetails']['testId']) {
          content[i]['testDetails']['isHidden'] = isHidden;
        }
    }
    cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(clonePhases)) }
    setTreeData({
        treeData: cloneTree
    });
  };
  
  componentDidMount = () => {
    const { preSelectedFilter = {} } = this.state;
    const { conceptPhaseData, preFilters, setPreFilters, getPackageByIdData, treeData } = this.props;
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
    const { content = [], courseSyllabusIds } = conceptPhaseData;
    const { courseDetails = [] } = getPackageByIdData;
    const courseId = _.get(courseSyllabusIds, `[0].courseId`, courseDetails[0].courseId);
    const showChapters=_.get(treeData,'displaySettings.showChapters',true);
    if(showChapters){
      this.callGoalsDrillersApi();
    }
    // this.handleSelectedFilterQuestion(content);
    // this.setSelectedQuestion();
  };

  handleInitialState = () => {
    this.setState({
      selectedQuestionCount: 0,
      selectedQuestion: []
    });
  };
  
  isLastConcept = () => {
    const { conceptPhaseData, treeData } = this.props;
    const {phases} = treeData;
    const currentChapter = phases[conceptPhaseData.phaseIndex].weeks[conceptPhaseData.weekIndex].subjects[conceptPhaseData.subjectIndex].chapters[conceptPhaseData.chapterIndex]
    return conceptPhaseData.conceptIndex === currentChapter.concepts.length - 1;
  }
  updateContentTypeValue = (e: any) => {
    let selectedContentType = e;
    this.setState({ isChapterLevel:selectedContentType=='chapter'})
  }
  callGoalsDrillersApi=async ()=>{
    const { preSelectedFilter = {} } = this.state;
    const { conceptPhaseData, preFilters, setPreFilters, getPackageByIdData, treeData } = this.props;
    const { subjectIndex, weekIndex, phaseIndex, chapterIndex, conceptIndex } = conceptPhaseData;
    const { content = [], courseSyllabusIds } = conceptPhaseData;
    const { courseDetails = [] } = getPackageByIdData;
    const courseId = _.get(courseSyllabusIds, `[0].courseId`, courseDetails[0].courseId);
    const showChapters=_.get(treeData,'displaySettings.showChapters',true);
    if (!preFilters[`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]) {
       try{
        const courseData= await contentManagementService.getCourseDetails(courseId);
        const { courseType = {} } = courseData;
        const goalsList=await courseService.list();
        const { subjectId = '', chapterId = '', id } = conceptPhaseData;
        const masterIdOfSubject = subjectId;
        const masterIdOfChapter = chapterId;
        setGoalsDriller(
            goalsList,
            courseType,
            this.handleSetState,
            preSelectedFilter,
            conceptPhaseData,
            this.handlePreFiltersData,
            getPackageByIdData,
            treeData,
            masterIdOfSubject,
            masterIdOfChapter,
            id
          );
        }catch(err){
          console.log({err});
        }
    }
  }
  render = () => {
    const { conceptPhaseData, preFilters, bulkDrag, filterSelectedQuestion, classes, subjectTab, treeData,childIndex } = this.props;
    
    const { openMyLibray, selectedQuestionCount, bonusContent, openBonusContent, bonusCriteria = [],isChapterLevel } = this.state;
    const { name = '', subjectIndex, conceptIndex, chapterIndex, weekIndex, phaseIndex, content } = conceptPhaseData;

    const chapter = treeData.phases[phaseIndex].weeks[weekIndex].subjects[subjectIndex].chapters[chapterIndex];   
    const {displaySettings}=treeData;
    const showChapters=_.get(displaySettings,'showChapters',true);
    const showTestVisibility=_.get(displaySettings,'showTestVisibility',false);
    const hideChapterLevel =  chapter && chapter.hideChapterLevel ?chapter.hideChapterLevel : showChapters ? false:true;
    // const hideChapterLevel=true;
    return (
      <span className={classes.manageDragable}>
        <Droppable
          droppableId={
            bulkDrag[`concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]
              ? `concept-bulk-${phaseIndex}-${weekIndex}`
              : `concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`
          }
        >
          {(provided) => (
            <div ref={provided.innerRef}>
              <Draggable
                key={
                  bulkDrag[`concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]
                    ? `concept-bulk-${phaseIndex}-${weekIndex}`
                    : `concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`
                }
                draggableId={
                  bulkDrag[`concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]
                    ? `concept-bulk-${phaseIndex}-${weekIndex}`
                    : `concept-${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`
                }
                index={subjectIndex}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    onMouseEnter={this.enableDrag}
                    onMouseLeave={this.disableDrag}
                  >
                    <div>
                      {/* {this.state.isDragEnabled && (
                        <span {...provided.dragHandleProps} className={classes.handleDragIcon}>
                          <img src='/assets/img/course/make_sequence.png' alt='drag-icon' />
                        </span>
                      )} */}
                      {this.state.isOpened && (
                        <ul
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textDecoration: 'none',
                          }}
                        >
                          <ExpansionalPanel
                            name={`
                            ${childIndex + 1}. ${name}`}
                            data={content}
                            handleDeleteContent={this.handleDeleteContent}
                            isDeleted={true}
                            isAddContentRequired={true}
                            isAddBonusContentRequired={true}
                            toggleOpenMyLibrary={this.toggleOpenMyLibrary}
                            toggleAddBonusContent={this.toggleAddBonusContent}
                            bulkDragDetails={true}
                            bulkDrag={bulkDrag}
                            conceptPhaseData={conceptPhaseData}
                            handleOnChangeCheckBox={this.handleOnChangeCheckBox}
                            isExpansionPanelOpen={this.state.isExpansionPanelOpen}
                            isBulkDataAdded={conceptPhaseData.isBulkDataAdded}
                            showTestVisibility={showTestVisibility}
                            handleTestVisibilityToggle={(e:any,v:any)=>this.handleTestVisibilityToggle(e,v,true)}
                          />
                        </ul>
                      )}
                      {
                        Boolean(Object.keys(preFilters).length) &&
                        preFilters[`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${conceptIndex}`]
                        && (
                          <AddContent
                            openMyLibary={openMyLibray}
                            type='studyMaterial'
                            selectedQuestionCount={selectedQuestionCount}
                            handleContentSelectAll={this.handleContentSelectAll}
                            handleBackToComponent={this.toggleOpenMyLibrary}
                            handleContentSelect={this.handleContentSelectFromLibrary}
                            preSelectedFilterContent={
                              Boolean(Object.keys(preFilters).length) &&
                              preFilters[`${phaseIndex}-${weekIndex}-${subjectIndex}-${chapterIndex}-${isChapterLevel?conceptIndex+1:conceptIndex}`]
                            }
                            // preSelectedFilterContent={preFilters}
                            handleAddContent={this.handleAddContentFromLibrary}
                            isBonusContent={bonusContent}
                            bonusCriteria={bonusCriteria}
                            isConcept={!isChapterLevel}
                            isChapter={isChapterLevel}
                            // isCourse={!isChapterLevel}
                            handleInitialState={this.handleInitialState}
                            selectedContentType={isChapterLevel?"chapter":"concept"}
                            updateContentTypeValueParent={this.updateContentTypeValue}
                          />
                        )
                      }

                      <AddBonusDialog
                        isDialogOpen={openBonusContent}
                        handleOnClick={this.handleBonusContent}
                        handlePopUpClose={this.toggleAddBonusContent}
                      />
                    </div>
                  </div>
                )}
              </Draggable>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        {/* && conceptPhaseData.chapterContent && Boolean(conceptPhaseData.chapterContent.length)  */}
          {this.isLastConcept() && !hideChapterLevel
          // && !doesChapterAlreadyExist
          && (
             <div
             style={{
               borderTop: '1px solid lightgrey',
               marginLeft: '-77px',
                marginRight: '-30px',
               marginTop: '20px',
               paddingLeft: '70px',
               paddingRight: '40px',
               paddingTop: '20px',
             }}
           >
             {!hideChapterLevel && (
            <ExpansionalPanel
            name='Chapter Level Content'
            data={conceptPhaseData.chapterContent||[]}
            isDeleted={true}
            handleDeleteContent={this.handleDeleteContentFromChapter}
            isBulkDataAdded={conceptPhaseData.isBulkAdded}
            isAddContentRequired={true}
            isAddBonusContentRequired={true}
            toggleOpenMyLibrary={this.toggleOpenMyLibrary}
            toggleAddBonusContent={this.toggleAddBonusContent}
            // bulkDragDetails={true}
            // bulkDrag={bulkDrag}
            conceptPhaseData={conceptPhaseData}
            isChapterLevel={true}
            showTestVisibility={showTestVisibility}
            handleTestVisibilityToggle={(e:any,v:any)=>this.handleTestVisibilityToggle(e,v,false)}
            />
          )} 

              </div>
          )}
      </span>
    );
  };
}
const mapStateToProps = (state: any) => {
  return {
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
    bulkDrag: _.get(state, 'courseMangementData.contentManagementData.bulkDrag', {}),
    preFilters: _.get(state, 'courseMangementData.contentManagementData.preFilters', {}),
    getPackageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
    filterSelectedQuestion: _.get(state, 'courseMangementData.contentManagementData.filterSelectedQuestion', []),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPreFilters: contentManagementAction.setPreFilters,
      setTreeData: contentManagementAction.setTreeData,
      setBulkDrag: contentManagementAction.setBulkDrag,
      setFilterSelectedQuestion: contentManagementAction.setFilterSelectedQuestion,
      showMessage: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(ConceptPhase));
